import { useContext, useRef, useEffect } from 'react';
import { useQuery as useQueryOriginal } from 'react-query';

import Axios from 'axios';

import MessageContext from './MessageContext';
import { SilentContext } from './Silent';

export const useQuery = (
  queryKey,
  queryFn,
  { disabledErrorMessage, ...options } = {}
) => {
  const { showErrorMessage } = useContext(MessageContext);
  const { isSilentQuery } = useContext(SilentContext);
  const placeholderDataRef = useRef(undefined);
  const mounted = useRef(false);
  const { onSuccess, onError, ...otherOptions } = options;

  useEffect(() => {
    mounted.current = true;
    return () => (mounted.current = false);
  }, []);

  const query = useQueryOriginal(
    queryKey,
    ({ signal }) => {
      return queryFn({}, { signal });
    },
    {
      onSuccess: (data, ...other) => {
        if (mounted.current) {
          placeholderDataRef.current = data;
        }
        return onSuccess && onSuccess(data, ...other);
      },
      placeholderData: placeholderDataRef.current,
      onError: (error) => {
        if (Axios.isCancel(error)) {
          console.log('[Query] cancel error ignore');
          return;
        }
        if (!disabledErrorMessage && error?.message) {
          showErrorMessage(error.message);
        }

        onError?.(error);
      },
      retry: false,
      ...otherOptions,
    }
  );

  if (isSilentQuery(queryKey)) {
    return {
      ...query,
      isLoading: false,
      isFetching: false,
      isRefetching: false,
    };
  }
  return {
    ...query,
    ...(!options.keepPreviousData && options.enabled === false
      ? {
          data: options?.initialData,
          error: null,
        }
      : null),
    _isLoading: query.isLoading,
    isLoading: query.isLoading || (query.isPlaceholderData && query.isFetching), // TODO: revove this logic, it doesn't work with Optimistic Updates
  };
};
